import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PayGuard implements CanActivate {
  constructor(private cookieService: CookieService, private router: Router) {}
  
    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const hasPaymentData = localStorage.getItem('Data');
      if (hasPaymentData) {
        return true;
      } 
      else {
        this.router.navigate(['/cart']);
        return false;
      }
    }
  
}
